import _slicedToArray from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/web.structured-clone.js";
var __default__ = {
  name: "School",
  data: function data() {
    return {
      barData: [],
      pieChartData: [],
      currentObj: {},
      currentDate: "",
      updatedAt: "",
      schools: [],
      totalStudents: 0,
      totalAbsence: 0,
      totalInfection: 0,
      targetSchool: {},
      schoolBarData: [],
      schoolPieChartData: [],
      schoolMonthData: {},
      calenderMonth: {},
      calenderFirstDay: "",
      todaysMonth: {},
      schoolIdSelected: this.$route.params.id,
      monthList: [],
      barMonth: "",
      schoolBarMonth: "",
      selectedDay: moment().format("YYYY-MM-DD"),
      // 当日の日付
      schoolBarStackedData: {},
      intervalId: undefined
    };
  },
  head: {
    title: {
      inner: "スクール"
    },
    meta: []
  },
  watch: {
    isAuthenticated: {
      handler: function handler(v) {
        var _this = this;
        return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          var data, absenceBySchool;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!v) {
                  _context.n = 2;
                  break;
                }
                _this.barMonth = "current";
                _this.schoolBarMonth = "current";
                _context.n = 1;
                return Promise.all([getData("attendance_summary?dashboard=1&date=".concat(_this.selectedDay)), getData("attendance_summary?pieChart=1&date=".concat(_this.selectedDay, "&school_type=all")), getData("attendance_summary?bar=1&to=".concat(_this.selectedDay)), getData("attendance_summary?schoolPieChart=".concat(_this.$route.params.id, "&date=").concat(_this.selectedDay)), getData("attendance_summary?schoolBar=".concat(_this.$route.params.id, "&to=").concat(_this.selectedDay)), getData("grade?schoolTable=".concat(_this.$route.params.id, "&date=").concat(moment(_this.selectedDay).startOf("month").format("YYYY-MM-DD"))), getData("grade?schoolBarStacked=".concat(_this.$route.params.id))]);
              case 1:
                data = _context.v;
                absenceBySchool = data[0].items;
                _this.pieChartData = data[1].items;
                _this.barData = data[2].items;
                _this.schoolPieChartData = data[3].items;
                _this.schoolBarData = data[4].items;
                _this.schoolMonthData = data[5].items;
                _this.schoolBarStackedData = data[6].items;
                _this.schools = _this.mergeSchoolAbsence(absenceBySchool);
                _this.getTotal();
                _this.targetSchool = _this.schools.find(function (v) {
                  return v.id === Number(_this.$route.params.id);
                });
              case 2:
                return _context.a(2);
            }
          }, _callee);
        }))();
      },
      immediate: true
    },
    $route: function $route() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!_this2.$auth.isAuthenticated) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return Promise.all([getData("attendance_summary?schoolPieChart=".concat(_this2.$route.params.id, "&date=").concat(_this2.selectedDay)), getData("attendance_summary?schoolBar=".concat(_this2.$route.params.id, "&to=").concat(_this2.selectedDay)), getData("grade?schoolTable=".concat(_this2.$route.params.id, "&date=").concat(_this2.calenderFirstDay)), getData("grade?schoolBarStacked=".concat(_this2.$route.params.id))]);
            case 1:
              data = _context2.v;
              _this2.schoolPieChartData = data[0].items;
              _this2.schoolBarData = data[1].items;
              _this2.schoolMonthData = data[2].items;
              _this2.schoolBarStackedData = data[3].items;
              _this2.targetSchool = _this2.schools.find(function (v) {
                return v.id === Number(_this2.$route.params.id);
              });
              _this2.schoolIdSelected = _this2.$route.params.id;
            case 2:
              _this2.autoUpdateValue();
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  },
  created: function created() {
    moment.locale("ja");
    this.currentObj = moment();
    this.currentDate = this.currentObj.format("YYYY年MM月DD日");
    this.updatedAt = this.currentObj.format("HH時mm分");
    this.todaysMonth = this.currentObj.clone().startOf("month");
    this.calenderMonth = this.todaysMonth.clone();
    this.calenderFirstDay = this.calenderMonth.format("YYYY-MM-DD");
    this.createMonthList();
  },
  mounted: function mounted() {
    this.autoUpdateValue();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    // 10分ごとの自動更新
    autoUpdateValue: function autoUpdateValue() {
      var _this3 = this;
      this.intervalId = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var data, absenceBySchool;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!_this3.$auth.isAuthenticated) {
                _context3.n = 2;
                break;
              }
              _context3.n = 1;
              return Promise.all([getData("attendance_summary?dashboard=1&date=".concat(_this3.selectedDay)), getData("attendance_summary?pieChart=1&date=".concat(_this3.selectedDay, "&school_type=all")), _this3.barMonth === "current" ? getData("attendance_summary?bar=1&to=".concat(_this3.selectedDay)) : getData("attendance_summary?bar=1&".concat(_this3.barMonth)), getData("attendance_summary?schoolPieChart=".concat(_this3.$route.params.id, "&date=").concat(_this3.selectedDay)), _this3.schoolBarMonth === "current" ? getData("attendance_summary?schoolBar=".concat(_this3.$route.params.id, "&to=").concat(_this3.selectedDay)) : getData("attendance_summary?schoolBar=".concat(_this3.$route.params.id, "&").concat(_this3.schoolBarMonth)), getData("grade?schoolTable=".concat(_this3.$route.params.id, "&date=").concat(_this3.calenderMonth.startOf("month").format("YYYY-MM-DD"))), getData("grade?schoolBarStacked=".concat(_this3.$route.params.id, "&date=").concat(_this3.selectedDay))]);
            case 1:
              data = _context3.v;
              absenceBySchool = data[0].items;
              _this3.pieChartData = data[1].items;
              _this3.barData = data[2].items;
              _this3.schoolPieChartData = data[3].items;
              _this3.schoolBarData = data[4].items;
              _this3.schoolMonthData = data[5].items;
              _this3.schoolBarStackedData = data[6].items;
              _this3.schools = _this3.mergeSchoolAbsence(absenceBySchool);
              _this3.getTotal();
              _this3.currentObj = moment(); // 当日の日付
              _this3.currentDate = _this3.currentObj.format("YYYY年MM月DD日");
              _this3.updatedAt = _this3.currentObj.format("HH時mm分");
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      })), 600000);
    },
    // カレンダーの日付が変更されたとき
    changeDate: function changeDate() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var data, absenceBySchool;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!_this4.$auth.isAuthenticated) {
                _context4.n = 2;
                break;
              }
              _context4.n = 1;
              return Promise.all([getData("attendance_summary?dashboard=1&date=".concat(_this4.selectedDay)), getData("attendance_summary?pieChart=1&date=".concat(_this4.selectedDay, "&school_type=all")), getData("attendance_summary?bar=1&to=".concat(_this4.selectedDay)), getData("attendance_summary?schoolPieChart=".concat(_this4.$route.params.id, "&date=").concat(_this4.selectedDay)), getData("attendance_summary?schoolBar=".concat(_this4.$route.params.id, "&to=").concat(_this4.selectedDay)), getData("grade?schoolBarStacked=".concat(_this4.$route.params.id, "&date=").concat(_this4.selectedDay))]);
            case 1:
              data = _context4.v;
              absenceBySchool = data[0].items;
              _this4.pieChartData = data[1].items;
              _this4.barData = data[2].items;
              _this4.schoolPieChartData = data[3].items;
              _this4.schoolBarData = data[4].items;
              _this4.schoolBarStackedData = data[5].items;
              _this4.schools = _this4.mergeSchoolAbsence(absenceBySchool);
              _this4.getTotal();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getTotal: function getTotal() {
      var _this$schools$reduce = this.schools.reduce(function (sum, v) {
        return [sum[0] + v.student_count, sum[1] + v.pointsMap.absencePointsMap, sum[2] + v.pointsMap.infection];
      }, [0, 0, 0]);
      var _this$schools$reduce2 = _slicedToArray(_this$schools$reduce, 3);
      this.totalStudents = _this$schools$reduce2[0];
      this.totalAbsence = _this$schools$reduce2[1];
      this.totalInfection = _this$schools$reduce2[2];
    },
    schoolChange: function schoolChange() {
      if (this.schoolIdSelected === "dashboard") {
        this.$router.push("/dashboard");
      } else {
        this.$router.push("/school/".concat(this.schoolIdSelected));
        clearInterval(this.intervalId);
      }
    },
    changePrevMonth: function changePrevMonth() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var data;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!(_this5.calenderMonth.month() !== 3 && _this5.$auth.isAuthenticated)) {
                _context5.n = 2;
                break;
              }
              _this5.calenderMonth.subtract(1, "month");
              _this5.calenderFirstDay = _this5.calenderMonth.format("YYYY-MM-DD");
              _context5.n = 1;
              return getData("grade?schoolTable=".concat(_this5.$route.params.id, "&date=").concat(_this5.calenderFirstDay));
            case 1:
              data = _context5.v;
              _this5.schoolMonthData = data.items;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    changeNextMonth: function changeNextMonth() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var data;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (!(_this6.calenderMonth < _this6.todaysMonth && _this6.$auth.isAuthenticated)) {
                _context6.n = 2;
                break;
              }
              _this6.calenderMonth.add(1, "month");
              _this6.calenderFirstDay = _this6.calenderMonth.format("YYYY-MM-DD");
              _context6.n = 1;
              return getData("grade?schoolTable=".concat(_this6.$route.params.id, "&date=").concat(_this6.calenderFirstDay));
            case 1:
              data = _context6.v;
              _this6.schoolMonthData = data.items;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    createMonthList: function createMonthList() {
      this.monthList = [{
        month: this.todaysMonth.month() + 1,
        period: "from=".concat(this.todaysMonth.format("YYYY-MM-DD"), "&to=").concat(this.currentObj.format("YYYY-MM-DD"))
      }];
      for (var d = this.todaysMonth.clone().subtract(1, "month"); d.month() !== 2; d.subtract(1, "month")) {
        this.monthList.push({
          month: d.month() + 1,
          period: "from=".concat(d.format("YYYY-MM-DD"), "&to=").concat(d.clone().endOf("month").format("YYYY-MM-DD"))
        });
      }
    },
    barMonthChange: function barMonthChange() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var data, _data;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              if (!_this7.$auth.isAuthenticated) {
                _context7.n = 4;
                break;
              }
              if (!(_this7.barMonth === "current")) {
                _context7.n = 2;
                break;
              }
              _context7.n = 1;
              return getData("attendance_summary?bar=1&to=".concat(_this7.selectedDay));
            case 1:
              data = _context7.v;
              _this7.barData = data.items;
              _context7.n = 4;
              break;
            case 2:
              _context7.n = 3;
              return getData("attendance_summary?bar=1&".concat(_this7.barMonth));
            case 3:
              _data = _context7.v;
              _this7.barData = _data.items;
            case 4:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    schoolBarMonthChange: function schoolBarMonthChange() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var data, _data2;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              if (!_this8.$auth.isAuthenticated) {
                _context8.n = 4;
                break;
              }
              if (!(_this8.schoolBarMonth === "current")) {
                _context8.n = 2;
                break;
              }
              _context8.n = 1;
              return getData("attendance_summary?schoolBar=".concat(_this8.$route.params.id, "&to=").concat(_this8.selectedDay));
            case 1:
              data = _context8.v;
              _this8.schoolBarData = data.items;
              _context8.n = 4;
              break;
            case 2:
              _context8.n = 3;
              return getData("attendance_summary?schoolBar=".concat(_this8.$route.params.id, "&").concat(_this8.schoolBarMonth));
            case 3:
              _data2 = _context8.v;
              _this8.schoolBarData = _data2.items;
            case 4:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    }
  }
};
import { inject } from "vue";
import moment from "moment";
import { getData } from "@/services/axios";
import PieChart from "@/components/charts/PieChart";
import Bar from "@/components/charts/Bar";
import PointsMap from "@/components/charts/PointsMap";
import CalenderTable from "@/components/schools/CalenderTable";
import BarStacked from "@/components/charts/BarStacked";
import Inc137 from "@/components/common/Inc137";

import { isAuthenticatedKey, allSchoolListKey, meKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props, _ref2) {
    var expose = _ref2.expose;
    var isAuthenticated = inject(isAuthenticatedKey);
    var allSchoolList = inject(allSchoolListKey);
    var me = inject(meKey);

    // 表と地図のデータ作成
    var mergeSchoolAbsence = function mergeSchoolAbsence(absenceBySchool) {
      return allSchoolList.value.map(function (v) {
        var school = structuredClone(v);
        var absence = absenceBySchool.find(function (w) {
          return w.school_id === school.id;
        });
        if (absence) {
          school["absence"] = absence;
          school["pointsMap"] = {
            absencePointsMap: absence.absencePointsMap,
            infection: Object.keys(absence).reduce(function (sum, key) {
              return key.match(/感染症/) ? sum + absence[key] : sum;
            }, 0)
          };
        } else {
          // 欠席者がいないとき
          school["absence"] = {
            total: 0
          };
          school["pointsMap"] = {
            absencePointsMap: 0,
            infection: 0
          };
        }
        return school;
      });
    };
    expose({
      isAuthenticated: isAuthenticated,
      mergeSchoolAbsence: mergeSchoolAbsence
    });
    return {
      __sfc: true,
      isAuthenticated: isAuthenticated,
      allSchoolList: allSchoolList,
      me: me,
      mergeSchoolAbsence: mergeSchoolAbsence,
      PieChart: PieChart,
      Bar: Bar,
      PointsMap: PointsMap,
      CalenderTable: CalenderTable,
      BarStacked: BarStacked,
      Inc137: Inc137
    };
  }
});